<template>
  <div class="top-header top">
    <div>
      <template v-if="env === 'prod'">
        <a href="https://app.fexspace.com">
          <img src="@/assets/logo-bbb-small.png" />
        </a>
      </template>
      <template v-if="env !== 'prod'">
        <router-link to="/">
          <img src="@/assets/logo-bbb-small.png" />
        </router-link>
      </template>
      <div class="search">
        <template v-if="env === 'local'">
          <ul class="url">
            <li>
              <a :href="protocol + '//' + host + ':9009'">Dashboard</a>
            </li>
            <li>
              <a :href="protocol + '//' + host + ':7080'">Drive</a>
            </li>
            <li v-if="$store.getters.USER_PLAN != 1">
              <a :href="protocol + '//' + host + ':3002/collaboration'"
                >Projects</a
              >
            </li>
            <li>
              <a :href="protocol + '//' + host + ':3002/tasks'"> Tasks </a>
            </li>
            <li>
              <a :href="protocol + '//' + host + ':3002/tasks'"> CRM </a>
            </li>
            <!--<li v-if="$store.getters.USER_PLAN != 1">
                    <a :href="protocol+'//'+host+':9009/contacts'">Contacts</a>
                  </li>-->
            <li v-if="$store.getters.USER_PLAN != 1">
              <a :href="protocol + '//' + host + ':9009/calendar/month'"
                >Schedules</a
              >
            </li>
            <li>
              <a :href="protocol + '//' + host + ':9009/m/chats'"
                >Conversations</a
              >
            </li>
            <template v-if="$store.getters.ACCT_TYPE == 2">
              <li>
                <a :href="protocol + '//' + host + ':9009/explore'">Feed</a>
              </li>
            </template>
            <template v-else>
              <li>
                <a :href="protocol + '//' + host + ':9009/explore'"
                  >Community</a
                >
              </li>
            </template>
            <li>
              <a :href="protocol + '//' + host + ':9009/m/meetings'">Meeting</a>
            </li>
            <li>
              <a :href="protocol + '//' + host + ':3002/teams'"> Teams </a>
            </li>
          </ul>
        </template>
        <template v-if="env === 'prod'">
          <ul class="url">
            <li>
              <a :href="DASHBOARD">Dashboard</a>
            </li>
            <li>
              <a :href="DRIVE">Drive</a>
            </li>
            <li v-if="$store.getters.USER_PLAN != 1">
              <a :href="PROJECTS">Projects</a>
            </li>
            <li>
              <a :href="TASKS">Task</a>
            </li>
            <!--<li v-if="$store.getters.USER_PLAN != 1">
                    <a href="https://app.fexspace.com/contacts">Contacts</a>
                  </li>-->
            <li v-if="$store.getters.USER_PLAN != 1">
              <a :href="CALENDAR">Schedules</a>
            </li>
            <li>
              <a :href="MESSAGE">Conversations</a>
            </li>
            <template v-if="$store.getters.ACCT_TYPE == 2">
              <li>
                <a :href="EXPLORE">Feed</a>
              </li>
            </template>
            <template v-else>
              <li>
                <a :href="EXPLORE">Community</a>
              </li>
            </template>
            <li>
              <a :href="MEETING">Meeting</a>
            </li>
            <li>
              <a :href="TEAMS">Team</a>
            </li>
          </ul>
        </template>
      </div>
      <div>
        <span class="welcome">
          Welcome<strong> {{ $store.getters.NAME }}</strong>
        </span>
        &nbsp;&nbsp;
        <span class="profile">
          <span> | </span>
          &nbsp;&nbsp;
          <span class="profile-pic" @click="user_dropdown">
            <span class="default-pic" v-if="!$store.getters.PHOTO">{{
              getName($store.getters.FIRSTNAME)
            }}</span>
            <img :src="$store.getters.PHOTO" v-if="$store.getters.PHOTO" />
          </span>
          <ul class="userdropdown" v-if="userdropdown" v-on-clickaway="hide">
            <li class="pic-house">
              <template v-if="!$store.getters.PHOTO">
                <span class="default-pic">{{
                  getName($store.getters.FIRSTNAME)
                }}</span>
              </template>
              <template v-if="$store.getters.PHOTO">
                <span class="trigger_pic_self">
                  <img
                    :src="$store.getters.PHOTO"
                    v-if="$store.getters.PHOTO"
                  />
                </span>
              </template>
              &nbsp;&nbsp;
              <span>{{
                $store.getters.FIRSTNAME + " " + $store.getters.LASTNAME
              }}</span>
            </li>
            <li class="d-flex flex-column" v-if="$store.getters.ACCT_TYPE == 2">
              <strong style="font-size: 12px">Organisation:</strong>
              <span style="font-size: 16px">{{ $store.getters.COMPANY }}</span>
            </li>
            <li>
              <span v-if="$store.getters.EMAIL">{{
                $store.getters.EMAIL
              }}</span>
              <i>
                <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                  <path
                    fill="#888"
                    d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"
                  />
                </svg>
              </i>
            </li>
            <li class="collapsable" @click="show_subdown">
              <p>
                <span>Settings</span>
                <i>
                  <svg
                    v-if="sub_dropdown"
                    style="width: 20px; height: 20px"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#888"
                      d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
                    />
                  </svg>
                  <svg
                    v-if="!sub_dropdown"
                    style="width: 20px; height: 20px"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="#888"
                      d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"
                    />
                  </svg>
                </i>
              </p>
              <ul v-if="!sub_dropdown">
                <li>
                  <router-link to="/">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    My Drive
                  </router-link>
                </li>
                <li v-if="$store.getters.ISADMIN">
                  <router-link to="/create-public-folder">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    <span>Create Public Folder</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.ISADMIN">
                  <router-link to="/create-department">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    <span>All Department</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.ISADMIN">
                  <router-link to="/group-folder-request">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    <span>Group Folder Request</span>
                  </router-link>
                </li>
                <!--<li v-if="$store.getters.ISADMIN"><router-link to="folder-access-control">Folder Access Control</router-link></li>-->
                <li v-if="$store.getters.ISADMIN">
                  <router-link to="/create-page">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    <span>Create a Page</span>
                  </router-link>
                </li>
                <li v-if="$store.getters.ISADMIN">
                  <router-link to="/all-users">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    All Users
                  </router-link>
                </li>
                <li v-if="$store.getters.ISADMIN">
                  <router-link to="/payments-billing">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    Payments & Billing
                  </router-link>
                </li>
                <template v-if="$store.getters.ACCT_TYPE == 1">
                  <li>
                    <router-link to="/payments-billing">
                      <i>
                        <svg
                          style="width: 12px; height: 12px"
                          viewBox="0 0 24 24"
                        >
                          <path
                            fill="#666"
                            d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                          />
                        </svg>
                      </i>
                      Payments & Billing
                    </router-link>
                  </li>
                </template>
                <li
                  v-if="
                    $store.getters.ACCT_TYPE == 2 && !$store.getters.ISADMIN
                  "
                >
                  <router-link to="/request-more-storage">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    <span>Request More Storage</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/usage-quota">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    <span>Usage Quota</span>
                  </router-link>
                </li>
                <li>
                  <router-link to="/update-profile">
                    <i>
                      <svg
                        style="width: 12px; height: 12px"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#666"
                          d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                        />
                      </svg>
                    </i>
                    <span>Update Profile</span>
                  </router-link>
                </li>
              </ul>
            </li>
            <li style="cursor: pointer" @click="invite">
              <span> Send invite link </span>
              <i>
                <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                  <path
                    fill="#888"
                    d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6M20 6L12 11L4 6H20M20 18H4V8L12 13L20 8V18Z"
                  />
                </svg>
              </i>
            </li>
            <li style="cursor: pointer" @click="copy_invite_link">
              <span> Referral link </span>
              <i>
                <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                  <path
                    fill="#888"
                    d="M19,21H8V7H19M19,5H8A2,2 0 0,0 6,7V21A2,2 0 0,0 8,23H19A2,2 0 0,0 21,21V7A2,2 0 0,0 19,5M16,1H4A2,2 0 0,0 2,3V17H4V3H16V1Z"
                  />
                </svg>
              </i>
              <input
                type="hidden"
                id="referral_link"
                :value="$store.getters.REFERRAL_LINK"
              />
            </li>
            <li @click="download" style="cursor: pointer">
              <span> Download File Syncing App </span>
              <i>
                <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                  <path
                    fill="#888"
                    d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"
                  />
                </svg>
              </i>
            </li>
            <li
              style="cursor: pointer"
              v-if="$store.getters.CURRENT_PLAN == 1"
            >
              <router-link to="/payments-billing" class="upgrade-btn">
                Upgrade to Pro
              </router-link>
            </li>
            <li class="logout" @click="logout">
              <span>Logout</span>
              <i>
                <svg style="width: 19px; height: 19px" viewBox="0 0 24 24">
                  <path
                    fill="#888"
                    d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z"
                  />
                </svg>
              </i>
            </li>
          </ul>
        </span>
      </div>
    </div>
  </div>
</template>
<style scoped>
.settings {
  cursor: pointer;
}
.default-pic {
  background: #e2e8f0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #71809a;
  width: 40px;
  height: 40px;
  font-size: 1.125rem;
  font-weight: bold;
}
</style>
<script>
import { directive as onClickaway } from "vue-clickaway";
import ClickOutside from "vue-click-outside";
import { mapMutations } from "vuex";
import cookies from "@/services/cookies";
import moment from "moment";
export default {
  props: {
    data: Object,
  },
  data() {
    return {
      settings_dropdown: false,
      userdropdown: false,
      sub_dropdown: true,
      show_min: false,
      env: process.env.NODE_ENV === "development" ? "local" : "prod",
      host: location.hostname,
      protocol: location.protocol,
      TASKS: process.env.VUE_APP_TASKS,
      TEAMS: process.env.VUE_APP_TEAMS,
      MESSAGE: process.env.VUE_APP_MESSAGE,
      MEETING: process.env.VUE_APP_MEETING,
      CALENDAR: process.env.VUE_APP_CALENDAR,
      PROJECTS: process.env.VUE_APP_PROJECTS,
      DRIVE: process.env.VUE_APP_DRIVE,
      DASHBOARD: process.env.VUE_APP_DASHBOARD,
      EXPLORE: process.env.VUE_APP_EXPLORE,
    };
  },
  methods: {
    ...mapMutations([
      "SET_SORT_TYPE",
      "SET_SORT_ORDER",
      "SET_VIEW_TYPE",
      "SORT_DIRECTORY_CHILDREN",
      "TOGGLE_CHAT",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "SET_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SORT_DIRECTORY_CHILDREN",
    ]),
    copy_invite_link() {
      let link = document.querySelector("#referral_link").value;
      let a = document.createElement("input");

      a.setAttribute("value", link);
      a.setAttribute("id", "referallink");
      a.click();
      a.style.position = "absolute";
      a.style.left = "-9999px";
      document.body.appendChild(a);
      let l = document.getElementById("referallink");
      l.select();
      document.execCommand("copy");
      document.body.removeChild(a);

      let that = this;

      that.$toast.open({
        message:
          '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> Referral link copied to clipboard',
        type: "info",
        position: "bottom-left",
      });
    },
    invite() {
      this.$parent.invite();
    },
    getName(name) {
      return name[0];
    },
    download() {
      let a = document.createElement("a");
      a.setAttribute("download", true);
      let href = "https://fexspace.com/downloads/Fexspace-client-Setup.exe";
      a.setAttribute("href", href);
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    drop_min() {
      this.show_min = !this.show_min;
    },
    user_dropdown() {
      this.userdropdown = !this.userdropdown;
      this.sub_dropdown = false;
    },
    show_subdown() {
      this.sub_dropdown = !this.sub_dropdown;
    },
    format_date(date) {
      return moment(date).format("DD MMMM, YYYY");
    },
    logout() {
      this.$parent.logout();
    },
    slideout() {
      this.UPDATE_SLIDEIN(true);
      this.UPDATE_SLIDEOUT(false);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(true);
    },
    show_settings_dropdown() {
      if (this.settings_dropdown) {
        this.settings_dropdown = false;
      } else {
        this.settings_dropdown = true;
      }
    },
    hide() {
      this.settings_dropdown = false;
      this.userdropdown = false;
      this.sub_dropdown = false;
    },
    close_drop(e) {
      if (
        e.target.nodeName === "LI" ||
        e.target.nodeName === "I" ||
        e.target.nodeName === "IMG" ||
        e.target.nodeName === "svg" ||
        e.target.nodeName === "SPAN"
      ) {
        this.create_dropdown = false;
        this.sort_order = false;
        this.view_options = false;
      }
    },
  },
  directives: {
    onClickaway: onClickaway,
    ClickOutside,
  },
};
</script>
